import { useEffect, useState } from "react";

/**
 * useDebouncedValue — vrací hodnotu odloženou o `delay` ms.
 * Užitečné pro search inputy (zamezí spamu API).
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
